export const ClientGameDependencyTypes = {
  ClientGameApiService: Symbol.for('ClientGameApiService'),
  ClientGameApiDataTransformer: Symbol.for('ClientGameApiDataTransformer'),
  ClientGameRepository: Symbol.for('ClientGameRepository'),
  ClientGameService: Symbol.for('ClientGameService'),
  ClientGamesRefreshCompletionDispatcherService: Symbol.for('ClientGamesRefreshCompletionDispatcherService'),
};
